import Axios from 'axios';
var WalletService = (function () {
    function WalletService() {
    }
    WalletService.prototype.getWallet = function () {
        return Axios.get('supplierclientapi/wallet/mine');
    };
    WalletService.prototype.getRechargeBillList = function (params) {
        return Axios.get('supplierclientapi/wallet/recharge_bill_list', { params: params });
    };
    WalletService.prototype.rechargeCheck = function () {
        return Axios.get('supplierclientapi/wallet/recharge_check');
    };
    WalletService.prototype.payBillOrder = function (params) {
        return Axios.post('supplierclientapi/wallet/pay_bill_order', params);
    };
    WalletService.prototype.getRechargePosition = function () {
        return Axios.get('supplierclientapi/wallet/recharge_position');
    };
    WalletService.prototype.getRechargeActivity = function (params) {
        return Axios.get('supplierclientapi/wallet/recharge_activity', { params: params });
    };
    WalletService.prototype.getRecharge = function (params) {
        return Axios.get('supplierclientapi/wallet/recharge', { params: params });
    };
    WalletService.prototype.getLogList = function (params) {
        return Axios.get('supplierclientapi/wallet/log_list', { params: params });
    };
    WalletService.createInstance = function () {
        WalletService.getInstance();
    };
    WalletService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return WalletService;
}());
export default WalletService;
